import { render, staticRenderFns } from "./CtaCantSeePhotosInStay.vue?vue&type=template&id=2fba3a40&scoped=true"
import script from "./CtaCantSeePhotosInStay.vue?vue&type=script&lang=js"
export * from "./CtaCantSeePhotosInStay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fba3a40",
  null
  
)

export default component.exports